export default {
	addNewTask: {
		header: "Dodaj nowe zadanie",
		startTyping: "Opisz swoje zadanie",
		buttons: {
			add: "Dodaj",
			advancedAdd: "Zaawansowane dodawanie",
		},
		save: "Zapisz zadanie",
	},
	listOfTasks: {
		filters: {
			ascDeadline: "Sortuj od najkrótszego terminu",
			descDeadline: "Sortuj od najdłuższego terminu",
			ascPriority: "Sortuj od najmniejszego priorytetu",
			descPriority: "Sortuj od największego priorytetu",
			asc: "Sortuj alfabetycznie rosnąco",
			desc: "Sortuj alfabetycznie malejąco",
		},
		priority: {
			setPriority: "Ustaw priorytet",
			lack: "Brak",
			low: "Niski",
			medium: "Średni",
			hight: "Wysoki",
		},
		taskTitles: {
			task: "Zadanie",
			deadline: "Termin",
			priority: "Priorytet",
			type: "Typ",
		},
		noTask: {
			header: "Nie masz żadnych zadań",
			subtitle: "Może czas zaplanować nowe?",
		},
		tooltip: {
			delete: "Usuń",
			complete: "Zakończ",
			transfer: "Przekaż",
			list: "Ustaw listę",
			priority: "Ustaw priorytet",
			postpone: "Przełóż",
		},
		undoDelete: "Cofnij usunięcie",
		taskRow: {
			task: "Zadanie",
			deadline: "Termin",
			priority: "Priotytet",
			type: "Typ",
		},
	},
	stats: {
		header: "Statystyki",
		allTasks: "Wszystkich zadań",
		completedTasks: "Ukończonych zadań",
		createdLists: "Stworzonych list",
		addedTags: "Dodanych tagów",
	},
	tagMenu: {
		selectTag: "Wybierz tagi",
		addTag: "Dodaj nowy",
		selectedTags: "Wybrane",
		tagsList: "Lista tagów",
		tagName: "Nazwa tagu",
		selectColor: "Wybierz kolor",
		createAndSelect: "Stwórz tag i wybierz",
		
	},
	task: {
		tooltip: {
			commissionedFrom: "Zlecone od",
			commissionedTo: "Zlecone do",
		},
	},
	taskEditDialog: {
		createdDate: "Data utworzenia:",
		deadline: "Termin",
		onList: "Na liście:",
		priorityName: "Priorytet",
		assignTask: "Przypisz zadanie do:",
		addAtachement: "Dodaj załącznik",
		taskList: "Lista zadań",
		addNewPosition: "Dodaj kolejną pozycję",
		addTask: "Dodaj zadanie",
		notes: "Notatki",
		optional: "opcionalne",
		addNote: "Dodaj notatkę",
		cancel: "Anuluj",
		save: "Zapisz",
		select: "Wybierz",
		saveTask: "Zapisz zadanie",

		priority: {
			lack: "Brak",
			low: "Niski",
			medium: "Średni",
			hight: "Wysoki",
		},
	},
	taskMenu: {
		toDo: "Do zrobienia",
		allTasks: "Wszystkie zadania",
		todayTasks: "Na dziś",
		tomorrowTasks: "Na jutro",
		weekTasks: "W tym tygodniu",
		lists: "Listy",
		tags: "Tagi",
		completed: "Zakończone",
		deleted: "Usunięte",
		private: "Prywatne",
		job: "Praca",
		ordered: "Zlecone",
		recived: "Otrzymane",
		createNewList: "Stwórz nową listę",
		addList: "Dodaj listę",
		add: "Dodaj",
		received: "Otrzymane",
		commissioned: "Zlecone"
	},
	validation: {
		tagname: "Nazwa tagu jest wymagana",
	},
	taskWall: {
		noTasks: "Brak zadań na dziś",
		hour: "Do godz. ",
		expired: "(przedawnione)",
		add: "Dodaj nowe",
		goTasks: "Pokaż więcej",
		cancel: "Anuluj",
		todo: "Do zrobienia dziś",
	},
};
